import * as React from 'react';
import { SVGProps } from 'react';
const ManagerLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#143980"
      d="M11.991 4.478a2.239 2.239 0 1 0 0-4.478 2.239 2.239 0 0 0 0 4.478Z"
    />
    <path
      fill="#143980"
      d="M9.048 8.086c.333.315.981.537 1.333.537.795.018 2.424.018 3.22 0 .425 0 .943-.148 1.332-.537.721-.703 2.85-2.85 2.85-2.85.536-.536.647-1.406.203-2.035-.574-.814-1.721-.87-2.387-.203 0 0-1.703 2.109-2.498 2.498-.5.24-1.721.222-2.24 0-.814-.333-2.479-2.48-2.479-2.48-.536-.537-1.406-.648-2.035-.204-.814.574-.87 1.721-.204 2.388.019 0 2.147 2.165 2.905 2.886Z"
    />
    <path
      fill="#7F87B6"
      d="M11.991 24a2.239 2.239 0 1 0 0-4.477 2.239 2.239 0 0 0 0 4.477Z"
    />
    <path
      fill="#7F87B6"
      d="M9.048 15.914c.333-.315.981-.537 1.333-.537a93.399 93.399 0 0 1 3.22 0c.425 0 .943.148 1.332.537.721.703 2.85 2.85 2.85 2.85.536.536.647 1.406.203 2.035-.574.814-1.721.87-2.387.204 0 0-1.703-2.11-2.498-2.499-.5-.24-1.721-.222-2.24 0-.814.333-2.479 2.48-2.479 2.48-.536.537-1.406.648-2.035.203-.814-.573-.87-1.72-.204-2.387.019-.018 2.147-2.183 2.905-2.886Z"
    />
    <path
      fill="#A3A8CC"
      d="M2.239 14.229a2.239 2.239 0 1 0 0-4.478 2.239 2.239 0 0 0 0 4.478Z"
    />
    <path
      fill="#A3A8CC"
      d="M8.086 14.951c.315-.333.537-.98.537-1.332.018-.796.018-2.424 0-3.22 0-.425-.148-.944-.537-1.332-.703-.74-2.85-2.868-2.85-2.868-.536-.537-1.406-.648-2.035-.204-.814.574-.87 1.721-.203 2.387 0 0 2.109 1.703 2.498 2.498.24.5.222 1.721 0 2.24-.333.814-2.48 2.479-2.48 2.479-.537.537-.648 1.406-.204 2.035.574.814 1.721.87 2.388.204 0-.019 2.165-2.128 2.886-2.887Z"
    />
    <path
      fill="#4B5B98"
      d="M21.76 14.23a2.239 2.239 0 1 0 0-4.478 2.239 2.239 0 0 0 0 4.478Z"
    />
    <path
      fill="#4B5B98"
      d="M15.914 14.951c-.315-.333-.537-.98-.537-1.332a93.404 93.404 0 0 1 0-3.22c0-.425.148-.944.537-1.332.703-.722 2.85-2.85 2.85-2.85.536-.536 1.406-.647 2.035-.203.814.573.87 1.72.203 2.387 0 0-2.11 1.702-2.498 2.498-.24.5-.222 1.72 0 2.239.333.814 2.48 2.48 2.48 2.48.536.536.648 1.406.203 2.035-.573.814-1.72.87-2.387.203-.018-.037-2.183-2.146-2.886-2.905Z"
    />
  </svg>
);
export default ManagerLogo;
